import { render, staticRenderFns } from "./tabProject.vue?vue&type=template&id=ffd21b98&scoped=true"
import script from "./tabProject.vue?vue&type=script&lang=ts"
export * from "./tabProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd21b98",
  null
  
)

export default component.exports